globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Statistics = appCustomerSpace.Controllers.Statistics || {};

appCustomerSpace.Controllers.Statistics.AnalyticsController = (function(superClass) {

  utils.extend(AnalyticsController, superClass);

  function AnalyticsController() {
    return AnalyticsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(AnalyticsController.prototype, {
    init: function() {
      this.initChart();

      return AnalyticsController.__super__.init.apply(this, arguments);
    },
    initChart : function() {
      var controller  = this,
          $container  = $('#highcharts-container'),
          $pickerBtn  = $("#range-picker"),
          ajaxUrl     = $container.data('ajax-url'),
          errorMsg    = 'Erreur de chargement des données',
          queryString = window.location.search,
          containerLoaderOptions = {
            $container: $container,
            options: {
              style: {
                backdrop: {
                  background: "#f9f9f9"
                },
                spinner: {
                  marginBottom: "0"
                }
              }
            }
          },
          pickerLoaderOptions    = {
            $container: $pickerBtn,
            options: {
              text: "",
              icon_size: "1x",
              style: {
                backdrop: {
                  background: "#ffffff"
                },
                spinner: {
                  marginBottom: "0"
                },
                error: {
                  marginBottom: "0"
                }
              }
            }
          }

      appCustomerSpace.Loader().start(containerLoaderOptions);
      appCustomerSpace.Loader().start(pickerLoaderOptions);

      if(ajaxUrl) {
        $.get(ajaxUrl + queryString, function(data) {
          if(data.response) {
            appCustomerSpace.Loader().stop(containerLoaderOptions, function() {
              appCustomerSpace.Loader().stop(pickerLoaderOptions);

              $html = $(data.html);
              $container.append($html);

              appCustomerSpace.LimitlessPlugins.initPlugins($html);
              appCustomerSpace.Plugins.initPlugins($html);
              appCustomerSpace.Modules.initModules($html);

              controller.dateRangePicker(data);
              controller.events();
            });
          } else {
            $.extend(true, containerLoaderOptions, { options: { text: errorMsg, error: { persisted: true } } });
            $.extend(true, pickerLoaderOptions, { options: { error: { persisted: true } } })
            appCustomerSpace.Loader().error(containerLoaderOptions);
            appCustomerSpace.Loader().error(pickerLoaderOptions);
          }
        }).fail(function() {
          $.extend(true, containerLoaderOptions, { options: { text: errorMsg }, error: {persisted: true } });
          $.extend(true, pickerLoaderOptions, { options: { error: { persisted: true } } })
          appCustomerSpace.Loader().error(containerLoaderOptions);
          appCustomerSpace.Loader().error(pickerLoaderOptions);
        });
      } else {
        appCustomerSpace.Loader().stop({ $container: $('.content-wrapper') });
      }
    },
    events: function() {
      this.collapseContainer();
      this.showItems();
    },
    collapseContainer: function(){
      var me = this,
          $btnCollapser = $('.tr-collapsed-toggle');

      $btnCollapser.on('click', function(){
        var $this               = $(this),
            $tr                 = $this.parent().parent();
            targetIndex         = $this.data("target-tr");
            $containerCollapsed = $(`.collapsed-tr.tr-${targetIndex}`);

        if($this.hasClass("open")) {
          $this.removeClass('open');
          $containerCollapsed.removeClass("open");
        } else {
          $this.addClass('open');
          $containerCollapsed.addClass("open");
        }
      });
    },
    dateRangePicker: function(data) {
      var picker = new DateRangePicker($('#range-picker').show(), data, {
        opens: 'left',
        ranges: this._ranges(data["min_date"])
      });
    },
    showItems: function() {
      // TODO: Remove and use TableShowMore module
      $('tr.show-items').on('click', function() {
        var $this   = $(this),
            offset  = parseInt($(this).data('items-offset')),
            $hidden = $this.siblings('tr:not(.collapsed-container):hidden'),
            $shown  = $this.siblings('tr:not(.collapsed-container).shown'),
            texts   = {
              more: appCustomerSpace.Modules.Charts.lang.t('commons.seeMore'),
              less: appCustomerSpace.Modules.Charts.lang.t('commons.seeLess'),
              all: appCustomerSpace.Modules.Charts.lang.t('commons.seeAll')
            },
            totalHidden = $hidden.length;

        if(totalHidden > 0) {
          if(!$this.data('no-more-items')) $hidden = $hidden.slice(0, offset);
          $hidden.show().addClass('shown');
          if(totalHidden > offset) {
            text = $this.data('no-more-items') ? texts.less : texts.more;
          } else {
            $this.data('no-more-items', true);
            text = texts.less;
          }
        } else {
          $shown.hide().removeClass('shown');
          text = texts.all;
        }

        $this.find('td a').text(text);
      });
    },
    _ranges: function(minDate) {
      var me = this,
          ranges = {};

      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.all')] = [moment(new Date(minDate)), moment()]
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.thisWeek')] = [moment().startOf('isoWeek'), moment()];
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.lastWeek')] = [moment().startOf('isoWeek').subtract(1, 'week'), moment().subtract(1, 'week').endOf('isoWeek')];
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.twoWeeksAgo')] = [moment().startOf('isoWeek').subtract(2, 'week'), moment().subtract(2, 'week').endOf('isoWeek')];

      $.each([0, 1, 2, 3, 4], function(value) {
        var month = utils.capitalize(moment().subtract(value, 'month').format('MMMM YYYY'));
        ranges[month] = [moment().subtract(value, 'month').startOf('month'), (value == 0 ? moment() : moment().subtract(value, 'month').endOf('month'))];
      });

      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.lastSemester')] = [moment().subtract(6, 'months').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.beforeLastSemester')] = [moment().subtract(1, 'year').startOf('month'), moment().subtract(7, 'months').endOf('month')];

      return ranges;
    }
  });

  return AnalyticsController;

})(appCustomerSpace.Controllers.Statistics.MainController);
